function get_price(){
  var mf = "";
  var total = 0;
  $('.stlpopup-wrap').each(function(){
    total = total + parseInt($(this).find('input[name="variant_id"]').attr('data-price'));
  });
  $('.price_in_popup').html(Shopify.formatMoney(total, mf));
}
$(document).ready(function(e) {
  
  $('body').on("click", ".open-cookie-popups", function(e) {
    e.preventDefault();
    $('#ot-sdk-btn').trigger('click');
  });
  
  jQuery('body').on('click', '.mobileNav', function(e){
    e.preventDefault();
    if (localStorage.getItem('visual') == null) {
      setTimeout(function(){
        jQuery('body').toggleClass('menuOpen');
        jQuery('.fullPage').toggleClass('witmenu');
      }, 100);
    }
  });
   $('.colorVar').each(function(){
        var a= $(this)
        var u = a.attr('href');
        $.getJSON(u,function(p){
          a.addClass('show');
        }).error(function() { 
          a.hide(); 
        });
      });
    
    $('.customColor').each(function(){
        var a= $(this)
        var u = a.attr('href');
        $.getJSON(u,function(p){
          a.parent('.custom').addClass('show');
        }).error(function() { 
          a.hide(); 
        });
      });

  $('.sq_insta_wp').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed : 500,
    autoplay: true,
    autoplaySpeed: 3000,
    touchThreshold: 100,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  if ($(window).width() <= 991) {
    $('.new-api-slider').slick({
      infinite: true,
      centerMode: false,
      arrows: false,
      dots: false, 
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: 'linear'
    });
  }

  $(".cm_faq_title").click(function () {
    $(".cm_faq_title").removeClass("active");
    $(".faq_item_content").slideUp();
    $(".cm_faq_title").find('button').attr("aria-expanded","false");
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
      $(this).find('button').attr("aria-expanded","true");
    }
  });

  $('body').on('click','.rotation-button', function(e){
    if ($(this).hasClass('is-playing')){
      $(this).removeClass('is-playing').addClass('is-stoped').find('.pause-container').addClass('is-hide');
      $('.sq_insta_wp').slick('slickPause');
      $(this).find('.resume-container').removeClass('is-hide');
    } else {
      $(this).removeClass('is-stoped').addClass('is-playing').find('.pause-container').removeClass('is-hide');
      $('.sq_insta_wp').slick('slickPlay');
      $(this).find('.resume-container').addClass('is-hide');
    }
  })
  
  /* new product page start */
  function cartCollectionSlider() {
    if ($('.cart-upsell-slider').length != 0) {
      if ($('body').hasClass('template-cart')) {
        if ($(window).width() < 768) {
          $('.upsell-mobile-slider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            autoplay: false,
            speed: 1000,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: $('.prev-mobile-arrow'),
            nextArrow: $('.next-mobile-arrow')
          });
        } else {
          $('.upsell-desk-slider').slick({
              infinite: true,
              arrows: true,
              dots: false,
              autoplay: false,
              speed: 1000,
              slidesToShow: 5,
              slidesToScroll: 1,
              prevArrow: $('.prev-desk-arrow'),
              nextArrow: $('.next-desk-arrow'),
              responsive: [
                  {
                      breakpoint: 1300,
                      settings: {
                          slidesToShow: 5
                      },
                  }
              ]
          });
        }
      } else {
        function goSlider() {
          if ($('.mini-cart-page-upsell .cart-upsell-slider').length > 0) {
            $('.mini-cart-page-upsell .cart-upsell-slider').slick({
              infinite: true,
              arrows: true,
              dots: false,
              autoplay: false,
              speed: 1000,
              slidesToShow: 2,
              slidesToScroll: 1,
              prevArrow: $('.n-prev-arrow'),
              nextArrow: $('.n-next-arrow'),
              responsive: [
                {
                  breakpoint: 1300,
                  settings: {
                      slidesToShow: 2
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                  slidesToShow: 2                
                  }
                }
              ]
            });
          } else {
            setTimeout(function() {
              goSlider();
            }, 1000)
          }
        }
        goSlider();
      }
    }
  }
  cartCollectionSlider();
  
  function scroll_stick_add_to_cart(){
    if($('.cutsom_button').length > 0 && (window.location.href.indexOf('is_sticky_atc=true') > -1 || window.sticky_add_to_cart == true)){
      $(".cutsom_button").removeClass("is-visible").removeClass("ProductStickyAddToCart");
      var scroll = $(window).scrollTop();

      var elemTop = $('.cutsom_button').offset().top;
      var elemBottom = elemTop + $('.cutsom_button').height();

      if (scroll >= elemBottom) {
        $(".cutsom_button").addClass("is-visible").addClass("ProductStickyAddToCart");
        if($(window).width() < 769){
          $('body').css("padding-bottom",$('.cutsom_button').outerHeight()+"px");
        }
      }
    }
  }

  scroll_stick_add_to_cart();

  $(window).scroll(function() {    
    scroll_stick_add_to_cart();
  });

  $window = $(window);
  $slick_slider = $('.proImgClrGroup');
  settings = {
    centerMode: false,
    arrows: false,
    dots: true, 
    autoplay: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  if ($window.width() <= 991) {
    $slick_slider.slick(settings);
  }
  $window.on('resize load', function () {
    if ($window.width() > 991) {
      if ($slick_slider.hasClass('slick-initialized')) {
        $slick_slider.slick('unslick');
      }
    } else if (!$slick_slider.hasClass('slick-initialized')) {
      return $slick_slider.slick(settings);
    }
    if ($('.cart-upsell-slider').length != 0  ){
      cartCollectionSlider();
    }
  });
  
  $('body').on("click",'.closeZoom', function(){
    closeZoom();
  });

  $('body').on("click", function(e) {
    if ($(e.target)[0] != $('.zoomImgsCont')[0] || $(e.target)[0] != $('.zoom_element')[0]) {
      if ($(e.target)[0] == $('.zoomImgsWrap')[0]) {
        closeZoom();
      }
    }
  });
  
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      closeZoom();
    }
  });
  
  var closeZoom = function () {
    $('.zoomImgsWrap').remove();
    $('body').removeClass('ovfHidden');
    $('.mainImg').removeClass('current');
  }

  var pt = window.sm_theme.variable.product_title;
  $('.proImgClrGroup .featuredSlide .zoom_object').on("click",function(){
    $('.proImgClrGroup .featuredSlide .zoom_object').removeClass('current');
    $(this).addClass('current');
    $('body').addClass('ovfHidden');
    $('body').append('<div class="zoomImgsWrap"><div class="zoomimage_wrapper"><div class="zoomImgsCont"></div> <button class="closeZoom">X</button></div></div>');
    $(this).closest('.proImgClrGroup').find('.product-image:not(.slick-cloned) .zoom_object').each(function() {
      if ($(this).hasClass('type_image')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<img class="zoomTo zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
        else
          $('.zoomImgsCont').append('<img class="zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
      } else if ($(this).hasClass('type_video')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<video class="zoomTo zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
        else
          $('.zoomImgsCont').append('<video class="zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
      }
    });

    var imgs = $(".zoomImgsCont .zoom_element");
    var count = imgs.length;

    imgs.load(function() {
      count--;
      if (!count) {
        //setTimeout(function(){
        var s = $(".zoomImgsCont .zoom_element.zoomTo").position().top;
        $('.zoomImgsCont').animate({ scrollTop: s }, 1000);
        //},500);
      }
    }).filter(function() { return this.complete; }).load();

  });
  /* new product page end */
  
  
  /***************** Start Klaviyo Function *************/


  function checkparam(email, source, form, errmsg, lang, actMark){

    if(email == "")
    {

      jQuery(errmsg).html("Enter email address.");
      jQuery(errmsg).show();
      return false;
    }
    else
    {
      if(!isValidEmailAddress(email)){
        jQuery(errmsg).html("Please enter valid e-mail.");
        jQuery(errmsg).show();
        return false;
      }
      else
      {

        var first_name = '';
        var last_name = '';

        // flag is for identifing for newsletter or signup
        // 1 is for newsletter
        // 0 for signup
        var flag = 1;

        klaviyoAPI(first_name, last_name, email, source, flag, form, lang, actMark);

        //  console.log(first_name, last_name, email, source, flag, form);

        return false;
      }
    }


  }



  function klaviyoAPI(first_name, last_name, email, source, flag, form, lang, actMark){

    // Klaviyo Newsletter list id
    var list_id = 'MmmE5c';

    var settings = {

      "async": true,

      "crossDomain": true,

      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",

      "method": "POST",

      "headers": {

        "content-type": "application/x-www-form-urlencoded",

        "cache-control": "no-cache"

      },


      "data": {

        "g": list_id,

        "$first_name": first_name,

        "$last_name": last_name,

        "email": email,

        "Locale": lang,

        "Accepts Marketing": actMark,

        "$fields": "$source, $first_name, $last_name, Locale",

        "$source": source,


      }

    };


    if(flag == 1){
      settings['data']['$fields'] = "$source, SMCA_Account, Locale, $first_name, $last_name, Accepts Marketing";      
      settings['data']['SMCA_Account'] = "True";
      //  settings['data']['Locale'] = lang;
    }


    switch (source) {

      case "Homepage Popup":
	
        $.ajax(settings).done(function (response) {

//            console.log(response);
          
          let message = '';
          let alreadySubscribed = response.data.is_subscribed;
          
          if (!alreadySubscribed) {
            if ( Weglot.getCurrentLang() == 'en') {
              message = '<span class="successMsg no-translate">Success! You’re subscribed! <br /><span>Would you like to subscribe to receive <a href="https://stevemaddenca.attn.tv/p/St8/landing-page" title="text messages" target="_blank"><u>text messages</u></a>?</span></span>'
            } else {
              message = '<span class="successMsg no-translate">Succès! Merci d’avoir adhéré!</span>';
            }
          } else {
            if ( Weglot.getCurrentLang() == 'en') {
              message = '<p class="err-msg no-translate">You’re already registered to our newsletter.</p>'
            } else {
              message = '<p class="err-msg no-translate">Vous êtes déjà inscrite à notre infolettre.</p>';
            }
          }

          form.hide();
          form.parent().append(successMsg);
          $('.nlMore input[type="email"]').val(email);

        })

        .fail(function (response) {
          
          let failMsg = '';
          
          
          if ( Weglot.getCurrentLang() == 'en') {
          	failMsg = '<p class="err-msg no-translate">An error has occurred. Please try again later!</p>';
          } else {
          	failMsg = '<p class="err-msg no-translate">Une erreur est survenue. Veuillez réessayer plus tard!</p>';
          }

          form.append(failMsg);

        });

        break;


      case "Site Signups (Footer)":

        $.ajax(settings).done(function (response) {

//            console.log(response);
          
          let message = '';
          let alreadySubscribed = response.data.is_subscribed;
          
          if (!alreadySubscribed) {
            if ( Weglot.getCurrentLang() == 'en') {
              message = '<span class="successMsg no-translate">Success! You’re subscribed! <br /><span>Would you like to subscribe to receive <a href="https://stevemaddenca.attn.tv/p/St8/landing-page" title="text messages" target="_blank"><u>text messages</u></a>?</span></span>'
            } else {
              message = '<span class="successMsg no-translate">Succès! Merci d’avoir adhéré!</span>';
            }
          } else {
            if ( Weglot.getCurrentLang() == 'en') {
              message = '<p class="err-msg no-translate">You’re already registered to our newsletter.</p>'
            } else {
              message = '<p class="err-msg no-translate">Vous êtes déjà inscrite à notre infolettre.</p>';
            }
          }


          form.hide();
          form.parent().append(message);
          $('.nlMore input[type="email"]').val(email);

        })

        .fail(function (response) {
          
          let failMsg = '';
          
          if ( Weglot.getCurrentLang() == 'en') {
          	failMsg = '<p class="err-msg no-translate">An error has occurred. Please try again later!</p>';
          } else {
          	failMsg = '<p class="err-msg no-translate">Une erreur est survenue. Veuillez réessayer plus tard!</p>';
          }

          form.append(failMsg);

        });

        break;


      default: 

        break;
    }

  } 

  /***************** End Klaviyo Function *************/
      
       function isValidEmailAddress(emailAddress) {
        var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(emailAddress);
      }
 
  function closePopup() {
    $('.popupBox').removeClass('fadeInUp');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.cls_popup').remove();
    $('body').removeClass('popupOpned');
    
    if($('#manvideo').length) {
      $('#manvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');   
    }
  }
  function openPopup(a) {
    $('.popupBox').addClass('fadeInUp');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
    $('body').addClass('popupOpned');
    $('.popupBox').append('<a class="cls_popup" ></a>');
  }
  
  $(window).scroll(function(e) {    
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  });
  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });

//   $('.topbar a, .topbarPoupOpen').on('click', function(e){
//     e.preventDefault();
//     openPopup('topbarShipping');
//   });


  $('.shippingInfoPopup').on('click', function(e){
    e.preventDefault();
    openPopup('smpassMoreInfo');
  });
  
//   $('.afterpayLink').on('click', function(e){
//     e.preventDefault();
//     openPopup('afterpayPopup');
//   });
  
  

  // function refreshHeigh() {
  //   var bh = $('.cartButtonOuter').height()+85;
  //   var vh = window.innerHeight;
  //   var newh = vh-bh;
  //   var qih = $('.quick-items').height();
  //   $('.cartDrawer').removeClass('nofix');
  //   $('.quick-items').removeAttr('style');
  //   if(newh > 115) { // 115 is one line-item height in cart 
  //     if(qih > newh) {
  //       $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
  //     }
  //   }
  //   else {
  //     $('.cartDrawer').addClass('nofix');
  //   }
  // }

  // refreshHeigh();
  
  $('.dropdownmenu').each(function(){
    var lp = $(this).offset().left;
    if(lp < 0) {
      $(this).parent().addClass('rmPosRel');
    }
  });
  $('.hasDropDown').hover(function(){
    var d = $(this).find('.dropdownmenu');
    if(d.length) {
      var lp = d.offset().left;
      if(lp < 0) {
        $(this).addClass('pushtoLeft');
      } else {
        $(this).removeClass('pushtoLeft');
      }
      var rp = ($(window).width() - (d.offset().left + d.outerWidth()));
      if(rp < 0) {
        $(this).addClass('pushtoRight');
      } else {
        $(this).removeClass('pushtoRight');
      }
      
      /*if($(window).width() > 991) {
        $('ul.column-4').each(function(){
          if($(this).hasClass('lessContainer')) {
            var ss = $('#mainNavDesk > #AccessibleNav > li:first-child').offset().left;
            $(this).css('padding', '20px '+ss+'px');
          } else {
            var ss = $('header .container').offset().left;
            $(this).css('padding', '20px '+ss+'px');
          }
        });
      }*/

    }
  });

  jQuery('.filterToggle').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      jQuery('body').addClass('filterOpen');
      jQuery('.fullPage').addClass('witmenu');
    }, 50);
  });

  jQuery('#mainNavMob').on('click','.toggleItem.level2',function(e){
    jQuery('.mobileMenu').addClass('mobfoxheight');
    jQuery('.mobileMenu')[0].scrollTop = 0;
    if(jQuery(this).hasClass('opend')) {
      jQuery('.toggleItem').removeClass('opend');
      jQuery('.dropdownmenu').removeClass('toggleSubMenu');
    } else {
      jQuery('.toggleItem').removeClass('opend');
      jQuery('.dropdownmenu').removeClass('toggleSubMenu');
      jQuery(this).addClass('opend');
      jQuery(this).parent().next('ul').addClass('toggleSubMenu');
    }
  });
  jQuery('#mainNavMob').on('click','.backTitle',function(e){
    jQuery('.toggleItem').removeClass('opend');
    jQuery('.dropdownmenu').addClass('hideToggleMenu');
    setTimeout(function(){
      jQuery('.dropdownmenu').removeClass('toggleSubMenu').removeClass('hideToggleMenu');
    },500);
    jQuery('.mobileMenu').removeClass('mobfoxheight');
  });

//   jQuery('#mainNavMob').on('click','.col_menu_only .menu_only_title',function(e){
//     var h = jQuery(this).closest('ul')[0].scrollHeight;
//     jQuery(this).closest('ul')[0].scrollTop = 0;
//     jQuery(this).closest('ul').css('overflow','hidden');
//     jQuery(this).next('ul').addClass('menu_step3'); //.css('min-height',h+'px');
//   });
  
  jQuery('#mainNavMob').on('click','.toggleItem.level3',function(e){
    jQuery(this).closest('li.col_menu_only').addClass('open_step3');
    jQuery(this).closest('ul.dropdownmenu').addClass('open_childofchild');
    localStorage.setItem("secondScroll", jQuery('.toggleSubMenu').scrollTop());
    jQuery(this).closest('ul.dropdownmenu')[0].scrollTop = 0;
  });
  jQuery('#mainNavMob').on('click','.backTitle3',function(e){
    jQuery(this).closest('li.col_menu_only').removeClass('open_step3');
    jQuery(this).closest('ul.dropdownmenu').removeClass('open_childofchild');
    jQuery(this).closest('ul.dropdownmenu')[0].scrollTop = localStorage.getItem("secondScroll");
  });

//   jQuery('#mainNavMob').on('click','.backTitle3',function(e){
//     var btn = jQuery(this);
//     btn.closest('.toggleSubMenu').removeAttr('style');
//     btn.closest('ul').addClass('hidemenu_step3');
//     setTimeout(function(){
//       btn.closest('ul').removeClass('menu_step3').removeClass('hidemenu_step3');
//     },500);
//   });

  
  jQuery('body').on('click',/*'.fullPage.witmenu,*/'.closemenu, .closecart', function(e){
    if(jQuery(this).closest('.colSidebar').length) {
      return false;
    }
    e.preventDefault();
    jQuery('body').removeClass('menuOpen');
    jQuery('.fullPage').removeClass('witmenu');
    jQuery('body').removeClass('filterOpen');
    jQuery('body').removeClass('cartOpen');
  });
  
  
  jQuery('.menu-overlay').on('click', function(e){
    e.preventDefault();
    jQuery('body').removeClass('menuOpen');
    jQuery('.fullPage').removeClass('witmenu');
    jQuery('body').removeClass('filterOpen');
    jQuery('body').removeClass('cartOpen');
  });
  
  
  
  $('.mobToggler').on('click',function(e){
    $(this).next('div').slideToggle();
    $(this).toggleClass('opned');
  });
  

  function addToCartSuccess() {
    if ($('.cartDrawer').length > 0) {
      $.get( "/cart?view=mini", function( data ) {
        // $('#crt').html(data);
        var new_data = data.split('[cartsplit]'), cart_count = 0;
        $('body #main-cart-wrapper #cart-item-form [data-cart-items]').html(new_data[0]);
        $('body #main-cart-wrapper .cartTotal[data-cart-subtotal]').html(new_data[1]);
        
        $('#crt').removeClass('loading');
        
        // setTimeout(function() {
        //   refreshHeigh();
        //   $('.cartDrawer').css("height", window.innerHeight+'px');
        // }, 100); 
        
        $(".wishlist_mini .swym-loaded").css('visibility','visible');	
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  
        themeLang(Weglot.getCurrentLang())
        Weglot.on('initialized', (lang) => {themeLang(lang)});
        Weglot.on('switchersReady', (lang) => {themeLang(lang)});
        Weglot.on('languageChanged', (lang) => {themeLang(lang)});
        
        changeTitle(Weglot.getCurrentLang(),$('.quick-cart-item'));
        Weglot.on('initialized', (lang) => {changeTitle(lang,$('.quick-cart-item'))});
        Weglot.on('switchersReady', (lang) => {changeTitle(lang,$('.quick-cart-item'))});
        Weglot.on('languageChanged', (lang) => {changeTitle(lang,$('.quick-cart-item'))});
  
        if ($('.mini-cart-page-upsell').length > 0){
          changeTitle(Weglot.getCurrentLang(),$('._product'));
          Weglot.on('initialized', (lang) => {changeTitle(lang,$('._product'))});
          Weglot.on('switchersReady', (lang) => {changeTitle(lang,$('._product'))});
          Weglot.on('languageChanged', (lang) => {changeTitle(lang,$('._product'))});
        }
        //Currency.convertAll(shopCurrency, $('.currentCurreny > span').text());
        //jQuery('.currentCurreny > span').text(Currency.currentCurrency); 
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
        cartCollectionSlider();
      });
      
      $.getJSON('/cart.js', function(c){
        if (c.item_count == 0){
          $('.cartButtonOuter').hide().parents('#crt').removeClass('has-item');
        } else {
          $('.cartButtonOuter').show().parents('#crt').addClass('has-item');
        }
      });
    }
  }

  function addToCartPageSuccess() {
    $.get(window.location.pathname, function(data) {
      $.getJSON('/cart.js', function(cart) {
        if (cart.item_count == 0) {
          var cartHtml = $(data).find('.main_cart_wrap').html();
          $('.main_cart_wrap').html(cartHtml);
        } else {
          var itemHtml = $(data).find('.cartItemProducts').html();
          var sideHtml = $(data).find('.cartTotalSide').html();
          $('.cartItemProducts').html(itemHtml);
          $('.cartTotalSide').html(sideHtml);
          $(".wishlist_mini .swym-loaded").css('visibility','visible');	
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

          changeTitle(Weglot.getCurrentLang(),$('.productItem'));
          Weglot.on('initialized', (lang) => {changeTitle(lang,$('.productItem'))});
          Weglot.on('switchersReady', (lang) => {changeTitle(lang,$('.productItem'))});
          Weglot.on('languageChanged', (lang) => {changeTitle(lang,$('.productItem'))});
        
          // Cart Upsell collection
          if ($('.cart-page-upsell').length > 0){
            changeTitle(Weglot.getCurrentLang(),$('._product'));
            Weglot.on('initialized', (lang) => {changeTitle(lang,$('._product'))});
            Weglot.on('switchersReady', (lang) => {changeTitle(lang,$('._product'))});
            Weglot.on('languageChanged', (lang) => {changeTitle(lang,$('._product'))});
          
            changeBtnText(Weglot.getCurrentLang(),$('._product'));
            Weglot.on('initialized', (lang) => {changeBtnText(lang,$('._product'))});
            Weglot.on('switchersReady', (lang) => {changeBtnText(lang,$('._product'))});
            Weglot.on('languageChanged', (lang) => {changeBtnText(lang,$('._product'))});
          }
          // Cart Upsell collection
                  
          if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
          }
          cartCollectionSlider();
        }
      });
    });
  }

  $('body').on('click', '.cartOuter', function(e) {
    if ($(this).find('.cartCount').text() != "0") {
      //addToCartSuccess();
      e.preventDefault();
      setTimeout(function(){
        $('body').addClass('cartOpen');
        $('.fullPage').addClass('witmenu');
      }, 50);
    }
  });
  

   
  // $('.cartCount').on("DOMSubtreeModified",function(){
  //   if (window.location.href.indexOf('/cart') == -1) {
  //     addToCartSuccess();
  //   }
  // });
  
  

  $('body').on('click','.addtocart',function(e){
    e.preventDefault();
    var btn = $(this), add_to_cart_location = '';
    var btnText = (Weglot.getCurrentLang() == 'en') ? 'Add to cart' : 'Ajouter au panier';
    var form = $(this).closest('form');

    if($(this).closest('.cutsom_button').hasClass('ProductStickyAddToCart')){
      if(form.find('.swatch.select_size input[type=radio]:checked').length <= 0){
        window.scroll({
         top: form.find('.swatch.select_size').offset().top, 
         left: 0, 
         behavior: 'smooth' 
        });
        return false;
      }
    }
    
    btn.attr('disabled', 'disabled');
    btn.val((Weglot.getCurrentLang() == 'en') ? 'Adding...' : 'Ajouter...');

    if (btn.hasClass('quickAdd')){
      add_to_cart_location = "Quick View"
    } else if (btn.parents('.completeLook').length > 0){
      add_to_cart_location = 'PDP Completethelook';
    } else {
      add_to_cart_location = 'Product Page';
    }
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
        btn.val(btnText);
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();

      var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
      var sizeVal='';
      try{
        sizeVal=data.variant_options[1].trim();
      }catch{}
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        addToCartLocation: add_to_cart_location,
        product: {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price)/100).toFixed(2),
            basePrice: (parseInt(data.original_price)/100).toFixed(2),
            quantity: data.quantity,
            brand: data.vendor,			
            color: data.variant_options[0].trim(),
            colorFamily: data.variant_options[0].trim(),
            size:sizeVal,
            expectedShipDate: expectedShipDate
        },
        productRaw: JSON.parse($('#product_json').html())
      });

      if (btn.parents('.it_style') && add_to_cart_location == 'Quick View') {
        document.dispatchEvent(new CustomEvent("addCart", {
          detail: { data: data }
        }))
      }

      if (add_to_cart_location == 'Product Page') {
        document.dispatchEvent(new CustomEvent("addCartMain", {
          detail: { data: data }
        }))
      }
      
      btn.val(btnText);
      btn.removeAttr('disabled');

      // QUICK SHOP
      if (btn.hasClass('quickAdd')) {
        $('.product_quickview, .overlay').removeClass('active');
        $('body').removeClass('Fixed');
      }
      // QUICK SHOP
      
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
      });
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
      setTimeout(function(){
        $(".wishlist_mini .swym-loaded").css('visibility','visible');
      },1000);
      
      setTimeout(function() {
       if (typeof dataLayerUpsellProducts !== 'undefined' && dataLayerUpsellProducts != '') {
          window.dataLayer.push({
            event: "Cart Upsell Items Displayed",
            productList: {
                name: "Complete Your Order",
                products: dataLayerUpsellProducts,
            },
            _clear: true,
          });
         window.dataLayer.push({
            event: "Product Slider Displayed",
            productList: {
                name: "Complete Your Order",
                products: dataLayerUpsellProducts,
            },
            _clear: true,
          });
        }
      }, );
              
      if(window.pintrk){
        pintrk('track', 'addtocart',{
          value: parseFloat(data.price / 100)*form.find('#quantity').val(),
          order_quantity: form.find('#quantity').val(),
          currency: $('body').data('currency_code'),
          product_id: data.id
        });
      }
      
    });

  });

  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cartCount').text(c.item_count);
      // if(!c.item_count) {
      //   $('.itemCount').text('0');
      //   $('#crt').empty();
      //   $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
      //   $('#crt').removeClass('has-item');
      //   $('#crt').removeClass('loading');
      // }/* else {
      //   addToCartSuccess();
      // }*/
        addToCartSuccess();
       setTimeout(function(){
        $(".wishlist_mini .swym-loaded").css('visibility','visible');
      },1000);
      
    });
  });

  $('body').on("click",".cart_remove",function(e){
    e.preventDefault();
    var id = $(this).data('id');
    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/update.js",
      data: 'updates['+id+']=0',
      error: function(x,y,z) {
        console.log('error on cart remove');
        console.log(x);
      }
    }).done(function(){
      addToCartPageSuccess()
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
      });
      setTimeout(function(){
        $(".wishlist_mini .swym-loaded").css('visibility','visible');
      },1000);
    });
  });

  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);


    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      },
      success: function(){
        addToCartSuccess();
        
         setTimeout(function(){
           $(".wishlist_mini .swym-loaded").css('visibility','visible');
         },1000);
        
        $.getJSON('/cart.js', function(c){
          $('.itemCount, .cartCount').text(c.item_count);
        });
        $('#crt').removeClass('loading');
      }
    });
  });

  // Cart upsell add to cart
  $('body').on('click','.upsell_add', function(e) {
    e.preventDefault();
    var btn = $(this);
    var id = btn.attr('data-id');
    var div = $(this).parents('._product');
    btn.attr('disabled', 'disabled');
    var atcLocation = '';
    if (btn.parents('.mini-cart-page-upsell').length > 0){
      atcLocation = "Mini Cart"
    } else {
      atcLocation = "Cart Page"
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: id, qauntity: 1},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        div.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.removeAttr('disabled');
      },
      success: function(data){
        var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'addToCart',
          addToCartLocation: 'Mini Cart',
          product: {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price)/100).toFixed(2),
            basePrice: (parseInt(data.original_price)/100).toFixed(2),
            quantity: data.quantity,
            brand: data.vendor,			
            color: data.variant_options[0].trim(),
            colorFamily: data.variant_options[0].trim(),
            size:data.variant_options[1].trim(),
            expectedShipDate: expectedShipDate
          }
        });
        btn.removeAttr('disabled');
        if (btn.parents('.mini-cart-page-upsell').length > 0){
          addToCartSuccess();
        } else {
          window.location.href = '/cart'
        }
        // updateCartEvent(data, 'add', 1);
      }
    });
  });
  // Cart upsell add to cart

  $('.item-quantityg').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  $('.tablist ul:not(.links) li').click(function(e){
    var currenTab = jQuery(this).data('id');
    if(typeof currenTab !== 'undefined') {
      e.preventDefault();
      jQuery('.tablist ul li').removeClass('activetab');
      jQuery('.relatedProductC').hide();
      jQuery(this).addClass('activetab');
      jQuery('#'+currenTab).show();
      if(jQuery('.responsive').hasClass('slick-initialized')) {
        jQuery('.responsive').slick('refresh');
      }
    }
  });

  // $('.responsive')
  // .on('afterChange init', function(event, slick, direction){
  //   // remove all prev/next
  //   slick.$slides.removeClass('prevdiv').removeClass('nextdiv');

  //   // find current slide
  //   for (var i = 0; i < slick.$slides.length; i++)
  //   {
  //     var $slide = $(slick.$slides[i]);
  //     if ($slide.hasClass('slick-current')) {
  //       // update DOM siblings
  //       $slide.prev().addClass('prevdiv');
  //       $slide.next().addClass('nextdiv');
  //       break;
  //     }
  //   }
  // })
  // .on('beforeChange', function(event, slick) {
  //   // optional, but cleaner maybe
  //   // remove all prev/next
  //   slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
  // })
  // .slick({
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         centerMode: true,
  //         centerPadding: '20%',
  //         focusOnSelect: true,
  //         slidesToShow: 1,
  //         arrows: false
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         focusOnSelect: true,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         arrows: true
  //       }
  //     }
  //   ]
  // });

//   $('.responsive').slick({
//     dots: false,
//     arrows: true,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3
//         }
//       },
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1
//         }
//       }
//     ]
//   });
  
  if($('#myVideo').length) {
    document.getElementById("myVideo").pause();
  }
  $(".fancybox_viral").click(function(event){
    event.preventDefault();
    document.getElementById("myVideo").play();
    $('.viralsweep_popup').addClass('open_viralpopup');
    $('body').addClass('open_viralpopupbody');
    $('html').addClass('open_viralpopuphtml');
  });
  $(".inner_viral_close").click(function(event){		
    event.preventDefault();
    document.getElementById("myVideo").pause();
    $('.viralsweep_popup').removeClass('open_viralpopup');
    $('body').removeClass('open_viralpopupbody');
    $('html').removeClass('open_viralpopuphtml');
  });
   
  

  
    /***** Start Popup & Footer Newsletter Klaviyo ********/
      

  $('.mainNewsletter').on('submit',function(e){
    // This prevents the form from submitting
    e.preventDefault();  
    // Capture form input
    var form = $(this);
    var formid = $(this).closest("form").attr("id");
    var email = form.find("input[type='email']").val().trim();
    var actMark = form.find('[name="accepts_marketing"]').is(':checked');
    var errmsg = $(this).find('.err-msg');
    var lang="en-us";
    $('.validateCheckbox, .err-msg').hide();
    if(Weglot.getCurrentLang()=="fr") {
      lang="fr-ca";
    }
    
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(email.trim() == '' || !regex.test(email)) {
      $(errmsg).show();
      return false;
    }
    
    if(!actMark) {
      $('.validateCheckbox').show();
      return false;
    }
    if(formid == "popupnewsletterform")    {
      var source = 'Homepage Popup';
      checkparam(email, source, form, errmsg, lang, actMark);

    } else if(formid == "footerNewsletter")    {					
      var source = 'Site Signups (Footer)';
      checkparam(email, source, form, errmsg, lang, actMark);
    }

  });

   /***** End Popup & Footer Newsletter Klaviyo ********/

   
  var baseURL = "https://services.stevemadden.ca/";
/*  $('.mainNewsletter').on('submit',function(e){
    // This prevents the form from submitting
    e.preventDefault();    
    var x = true;
    $('.err-msg').hide();
     debugger;
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
      var lang="en-us";
          if(Weglot.getCurrentLang()=="fr"){
          	lang="fr-ca";
          }
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().find('.err-msg').show();
      x = false;
    } else {
      em.parent().find('.err-msg').hide();
    }
debugger;
    if(x){
      $.ajax({
        type: "POST",
        url: baseURL + 'Responsys/AddNewsLetter',
        data: "email="+email+"&page=PopUp&langCode="+lang,
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span class='successMsg'>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
          $('.nlMore input[type="email"]').val(email);
          //openPopup('nlMsg');
        },
        error: function (e) {
          //debugger;
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });
  
  */
  
  
  $('#moreAboutYou').on('submit',function(e){
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }
    
    if($('#agreementSMPass:checked').length) {
      var pc = form.find("input[name='pcode']");
      if(pc.val().trim() == '') {
        pc.parent().append('<p class="err-msg">Please enter Postal code.</p>');
        x = false;
      } else {
        pc.parent().find('.err-msg').remove();
      }
      
      var tp = form.find("input[name='telephone']");
      if(tp.val().trim() == '') {
        tp.parent().append('<p class="err-msg">Please enter Telephone.</p>');
        x = false;
      } else {
        tp.parent().find('.err-msg').remove();
      }
    }

    if(x){
      var mydata={
        email: email,
        page:"Footer"
      };
      $.ajax({
        type: "POST",
        url: baseURL + '*********',
        data: mydata,
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
           
        },
        error: function (e) {
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });
  
  $('#shopify-section-footer a').each(function(){

    if($(this).html() == 'Accessibility Toolbar'){
      $(this).attr('id', 'accessibilityEnablerCustomTrigger');
    }

  });
  $(document).mouseup(function(e){
  var container = $('.inner_viral');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".viralsweep_popup").removeClass('open_viralpopup');
    $("body").removeClass('open_viralpopupbody');
    if($('#myVideo').length) {
      document.getElementById("myVideo").pause();
    }
  }
});
});


window.onload = function() {
  $('.full_banner').each(function(){
    var img = $(this).attr('data-banner');
    $(this).css('background-image','url('+img+')');
    $(this).find('img').attr('src',img);
  });
  if($(window).width() <= 991) {
    $('.afterLoad').each(function(){
      var img = $(this).attr('data-src');
      $(this).attr('src', img);
    });
  }
  if(window.location.href.indexOf("sienna-addy") > -1) {
    $(".checkout-link").on('click', function(){
      window.location.href="/cart";
    });
  } 
};

jQuery(document).ready(function() { 
  $('body').on('click','.close-icon, .count-shopping, .error-popup .close-error', function(e){
    jQuery('.stlPopupCont').html('<img class="stlLoading" src="https://cdn.shopify.com/s/files/1/2170/8465/files/Reload.svg?v=1614273530" alt="" />');
    jQuery('body').removeClass('popupOpned');
    jQuery('#stl-cont').hide();
    if(parseInt(jQuery('#stl-cont').attr('data-addcnt')) > 0){
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');  
      jQuery('#stl-cont').attr('data-addcnt',0);
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
      });
    }  
  });
  jQuery('body').on('click','.stl_btn, .product_img_gird', function(e){
    e.preventDefault();
    jQuery('#stl-cont').show();
    jQuery('body').addClass('popupOpned');
    var btnImg = jQuery(this).attr('data-image');
    var handle = '/products/'+jQuery(this).attr('data-product')+'?view=shopthelook';
    jQuery.get(handle, function(data) {
      if(data) {
        jQuery('.stlPopupCont').html(data);
        jQuery('#ex_0').attr('data-thumb',btnImg).html('<img src="'+btnImg+'" alt="" />');
      }
    });
  });
  $('body').on('click','.swatchClr', function(e){
    e.preventDefault();
    if($(this).hasClass('active'))
      return false;

    var a= $(this);
    var u = a.attr('href');
    var pid = a.attr('data-id');
    var pdiv = $(this).closest('.stlpopup-wrap');
    var stl = pdiv.find('.footer-leftcol').html();
    var handle = u+'?view=shopthelook1';
    var ph = u.replace('/products/');
    jQuery.get(handle, function(data) {
      pdiv.html(data);
      pdiv.attr('data-product',ph).attr('id', 'p'+pid)
      pdiv.find('.footer-leftcol').html(stl);
      $('.swatchClr:not(.done)').each(function(){
        var a= $(this);
        var u = a.attr('href');
        $.get(u+'?view=shopthelookClr',function(p){
          if(p=='') {
            a.hide();
          } else {
            if(a.hasClass('active')) {
              p.replace('replaceActive','active');
            } 
            a.html(p);
          }
        }).error(function() { 
          a.remove(); 
        });
        $(this).addClass('done');
      });
      if(jQuery('#sidebar .scrollbar-inner').length && typeof scrollbar !== 'undefined'){
        jQuery('#sidebar .scrollbar-inner').scrollbar();
      }
      if($(window).width() > 1024){
        $('.stlpopup-wrap .leftcol-wrap .img-wrap').each(function(i,v){
          $('#'+$(this).attr('id')).zoom();
        });
      }
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    });
  });

  $('body').on('click','.cart-button', function(e){
    e.preventDefault();
    var t = $(this);
    t.attr('disabled','disabled');
    var vid=[];
    //     $('body').find('.stlpopup-wrap.active').each(function(){
    //       var t1=$(this);
    //       var v = t1.find('input[name="variant_id"]').val();
    //       if(v != '' && v != null && v != undefined){
    //         vid.push(v);
    //       }
    //     });
    var v = $('body .stlpopup-wrap.active').find('input[name="variant_id"]').val();
    if(v != '' && v != null && v != undefined){
      vid.push(v);
    }
    if(vid.length == 0){
      $('.error-popup').show();
      $('body').addClass('select_size_popup');
      return false;
    }
    else{
      $('.error-popup').hide();
      $('body').removeClass('select_size_popup');
      let iterations = vid.length;
      var data = [];
      for (var i of vid.reverse()) {
        //if (!--iterations){
        var items = {};
        items.id = i;
        items.quantity = 1;
        var prop = {};
        prop['Shop the look'] = window.mptl;
        if($('body .stlpopup-wrap.active #productbarcode').length){
          prop['UPC'] = $('body .stlpopup-wrap.active #productbarcode').val();
        }
        if($('body .stlpopup-wrap.active #preordermessage').length){
          prop['EXPECTED SHIP DATE'] = $('body .stlpopup-wrap.active #preordermessage').val();
        }
        if($('body .stlpopup-wrap.active .back_order_properties').length){
          prop['Back-ordered items'] = $('body .stlpopup-wrap.active .back_order_properties').val();
        }
        if($('body .stlpopup-wrap.active .pre_order_properties').length){
          prop['Pre-ordered items'] = $('body .stlpopup-wrap.active .pre_order_properties').val();
        }
        items.properties = prop;
        data.push(items);
      }
      $.post('/cart/add.js', {
        items: data
      }, function(pro){
        t.removeAttr('disabled');
        $('#stl-cont').attr('data-addcnt',(parseInt($('#stl-cont').attr('data-addcnt')) + 1));
        $('body .stlpopup-wrap').find('.cart-count').text($('#stl-cont').attr('data-addcnt'));
        window.dataLayer = window.dataLayer || [];
        var c = pro.items[0];
        window.dataLayer.push({
          event: 'stl_add_to_cart',
          addToCart: {
            product: {
              id: c.product_id,
              sku: c.variant_id,
              style: c.sku,
              name: c.title,
              price: (parseInt(c.final_price)/100).toFixed(2),
              basePrice: (parseInt(c.original_price)/100).toFixed(2),
              quantity: 1,
              brand: c.vendor,
              upc: $('body .stlpopup-wrap.active #productbarcode').val(),
              isPreOrder: Number($('body .stlpopup-wrap.active .isPreOrder').val()),
              color: c.variant_options[0].trim(),
              colorFamily: c.variant_options[0].trim(),
              size:c.variant_options[1].trim(),
              expectedShipDate:""
            }
          },
          data: c
        })
        //         jQuery('body').removeClass('popupOpned');
        //         jQuery('#stl-cont').hide();
        //         $.getJSON('/cart.js', function(c){
        //           $('.cartCount').text(c.item_count);
        //         });
        //         $('body').addClass('cartOpen');
        //         $('.fullPage').addClass('witmenu');
      },'JSON').fail(function(response) {
        t.removeAttr('disabled');
        alert('Something went wrong...');
      })
    }
  });

  function additems(v){
    $.ajax({
      url: '/cart/add.js',
      data: { id: v },
      type: 'POST',
      dataType: 'json',
      async:false,
      success: function(cart){
        console.log(cart);
      },
      error: function(){
        console.log('error')
      }
    });
  }

  $(document).on('click','.stl-popup .rightcol-body .description.tabbing h3',function(){
    $(this).next().slideToggle();
    $(this).toggleClass('tabOpen');
  });
  $(document).on('change','.stlpopup-wrap .single-option-selector.size',function(){
    if($(this).val() == ''){
      $(this).closest('.stlpopup-wrap').find('#preproperties').remove();
      $(this).closest('.stlpopup-wrap').find('.tooltiptext').hide();
      $(this).closest('.stlpopup-wrap').find('input[name="variant_id"]').val('');
    }
  });
  
  $('body').on('keyup','.ui-autocomplete-input',function(){
    var val = $(this).val();
    if(typeof pintrk !== 'undefined' && val != ''){
      pintrk('track', 'search', {
        search_query: val
      });
    }
  });
  
  var href = window.location.href;
  if (href.indexOf('/pages/search-results?q') != -1 && (typeof pintrk !== 'undefined')){
    var val = href.split('?q=')[1];
    val = val.replace(/%20/g, " ");;
    if(val != ''){
      pintrk('track', 'search', {
        search_query: val
      });
    }
  }


/* maddenqood page*/
   $(window).scroll(function () { 
     if($('.maddenwood_header_section').length > 0){
      var scroll = $(window).scrollTop();
      if (scroll >= 200) {
          $(".maddenwood_header_right").addClass("maddenwood_header-sticky");
      } else {
          $(".maddenwood_header_right").removeClass("maddenwood_header-sticky");
      }
     }
 });    

    // $('.paloma-slider').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     fade: false,
    //     dots: true,
    //     adaptiveHeight: true
    // });

    
  if($(window).width() <= 991){
    var video_class = 'video.mobile_imgonly';
  } else{
    var video_class = 'video.desktop_imgonly';
  }
    //play button
    $("body").on('click','.main-btn.maddenwood_play_btn',function (e) {
      e.preventDefault();
        $(this).closest('.maddenwood_hero_section').find(".main-popup").toggleClass("active");
        $('body,html').toggleClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];
        if (get_video.paused){
          get_video.muted = false;
          get_video.play();
        }              
    });
    $("body").on("click",'.maddednwooed_popup .close-menu',function (e) {
      e.preventDefault();
        $(".main-popup").removeClass("active");
        $('body,html').removeClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];            
        get_video.muted = true;
        get_video.pause();                
    });
  /*maddenwood end */ 


   $('body').on("click",".trigger_banner img",function(e){
     e.preventDefault();
     var _this = $(this);
     if($(window).width() > 991){
      if($('a[title="'+$(this).attr("data-id")+'"]').closest('.isp_single_facet_wrapper').find('.isp_facet_check_box_icon_checked').length > 0 && $('a[title="'+$(this).attr("data-id")+'"]').find('.isp_facet_check_box_icon_checked').length == 0){
        $('a[title="'+$(this).attr("data-id")+'"]').closest('.isp_single_facet_wrapper').find('.isp_facet_check_box_icon_checked').trigger("click");  
      }  
      $('a[title="'+$(this).attr("data-id")+'"]').find('.isp_facet_check_box_icon').trigger("click");   
     } else{
        if($('.isp_filter_removable_tag[facet_name="Gifts"]').length > 0 && $('.isp_single_mobile_facet[facet_value="'+$(this).attr("data-id")+'"]').hasClass('selected_facet_isp') != true){
          $('.isp_filter_removable_tag.mobile[facet_name="Gifts"]').click();  
        }
         if ($('.isp_single_mobile_facet[facet_value="'+_this.attr("data-id")+'"]').hasClass('selected_facet_isp') != true) {
          setTimeout(function(){
            $('.isp_single_mobile_facet[facet_value="'+_this.attr("data-id")+'"]').click();   
            $('.apply_filters_btn').click();
          },3000);
         } else {
           $('.isp_filter_removable_tag.mobile[facet_name="Gifts"]').click();  
         } 

     }  
    window.scroll({
     top: $('#isp_center_container').offset().top, 
     left: 0, 
     behavior: 'smooth' 
    });
  });

   // complete the look Start
  var clickedBtn = false;
  $('.viewClDesc').on('click',function(e) {
    e.preventDefault();
    $(this).closest('.clItem').find('.clDesc').slideToggle();
    if (Weglot.getCurrentLang() == 'en'){
      if ($(this).text() == 'View details') $(this).html(`Hide details`);
      else $(this).html(`View details`);
    } else {
      if ($(this).text() == 'Voir les détails') $(this).html('Cacher les détails');
      else $(this).html('Voir les détails');
    }
  });
  jQuery('.clSize').on('change',function() {
    var optionIndex = jQuery(this).closest('.clSw').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });
  function changeComplete(lang){
    if ($('body').hasClass('template-product') && $('.completeLook').length > 0){
      if (lang == 'en'){
        $('.clItem').each(function(i, ele){
          if ($(ele).find('.viewClDesc').text() == 'Cacher les détails' && $(ele).find('.clDesc').is(":visible")) $(ele).find('.viewClDesc').html(`Hide details`);
          else if ($(ele).find('.viewClDesc').text() == 'Voir les détails' && !$(ele).find('.clDesc').is(":visible")) $(ele).find('.viewClDesc').html(`View details`);
          else if ($(ele).find('.viewClDesc').text() == 'Voir les détails') $(ele).find('.viewClDesc').html(`View details`); 
        })  
      } else {
        $('.clItem').each(function(i, ele){
          if ($(ele).find('.viewClDesc').text() == 'Hide details' && $(ele).find('.clDesc').is(":visible")) $(ele).find('.viewClDesc').html('Cacher les détails');
          else if ($(ele).find('.viewClDesc').text() == 'Show details' && !$(ele).find('.clDesc').is(":visible")) $(ele).find('.viewClDesc').html('Voir les détails');
          else if ($(ele).find('.viewClDesc').text() == 'Show details') $(ele).find('.viewClDesc').html(`View details`);
        })
      }
    }
  }
  Weglot.on('languageChanged', (lang) => {changeComplete(lang)});

  if ($('body').hasClass('template-product') && $('.clItem').length > 0){
    changeTitle(Weglot.getCurrentLang(),$('.clItem'));
    Weglot.on('initialized', (lang) => {changeTitle(lang,$('.clItem'))});
    Weglot.on('switchersReady', (lang) => {changeTitle(lang,$('.clItem'))});
    Weglot.on('languageChanged', (lang) => {changeTitle(lang,$('.clItem'))});
  }
  if ($('body').hasClass('template-product') && $('.complete_the_look_grid').length > 1){
    var sortedDivs = jQuery(".completeLook").find(".complete_the_look_grid").toArray().sort(function(a, b){return parseInt(b.getAttribute('data-complte_price')) - parseInt(a.getAttribute('data-complte_price'))});
    jQuery.each(sortedDivs, function(index, value) {
      jQuery(".completeLook").append(value);
    });
    if ($('.complete_the_look_sale_grid').length > 0){
      var sortedDivs = jQuery(".completeLook").find(".complete_the_look_sale_grid").toArray().sort(function(a, b){return parseInt(b.getAttribute('data-complte_price')) - parseInt(a.getAttribute('data-complte_price'))});
      jQuery.each(sortedDivs, function(index, value) {
        jQuery(".completeLook").append(value);
      });
    }
  }
  // complete the look End

  // Quick Shop Start
  $('body').on('click', '.close-quick, .overlay', function(e) {
    var getProductData = JSON.parse($(this).parents('.main-quick').find('#product_json').html());
    $('.product_quickview, .overlay').removeClass('active');
    $('body').removeClass('Fixed');
    $('.product_quickview').empty();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quick_view_close',
      quickviewProduct: getProductData,
      _clear: true,
    });
  });

  $('body').on('click','.main-quick .select_color .swatch-element a', function (e) {
    e.preventDefault();
    var product_handle = $(this).attr('href');
    getProductData(product_handle, e, Weglot.getCurrentLang());
  });
  // Quick Shop End
});